/**
 * Shared utility functions for invoice attachment form processing.
 * Used by CustomerInvoiceFormService and QuickInvoiceFormService.
 */

/**
 * Sanitizes a filename by replacing invalid path characters with underscores.
 * @param name The filename to sanitize
 * @returns Sanitized filename safe for file system operations
 */
export function sanitizeFilename(name: string): string {
	if (!name) return 'attachment';
	return name.replace(/[/\\:*?"<>|]/g, '_');
}

/**
 * Prepares a form request with attachments for submission.
 * Handles file attachments by appending them to FormData and tracking file indices.
 * @param request The request object containing attachments
 * @returns FormData ready for HTTP submission
 */
export function setupAttachmentFormRequest(request: any): FormData {
	const formData: FormData = new FormData();
	const reqCopy = structuredClone(request);
	const attachmentsWithFiles = [];
	let fileIndexCounter = 0;

	if (request.attachments && request.attachments.length > 0) {
		request.attachments.forEach((att) => {
			if (att.file) {
				const fileExtension = att.file.name.substring(att.file.name.lastIndexOf('.'));
				const filename = sanitizeFilename(att.title) + fileExtension;
				const fileIndex = att.fileIndex !== undefined && att.fileIndex !== null ? att.fileIndex : fileIndexCounter;
				formData.append(`attachmentFile_${fileIndex}`, att.file, filename);
				attachmentsWithFiles.push({
					...att,
					fileIndex,
					file: undefined,
				});

				if (att.fileIndex === undefined || att.fileIndex === null) {
					fileIndexCounter++;
				} else {
					fileIndexCounter = Math.max(fileIndexCounter, fileIndex + 1);
				}
			} else {
				attachmentsWithFiles.push(att);
			}
		});
	}
	reqCopy.attachments = attachmentsWithFiles;
	formData.append('model', JSON.stringify(reqCopy));
	return formData;
}
